import React, {useEffect, useState} from "react";
import ChatComponent from "../ChatComponent/ChatComponent";
import PhoneNumbers from "../PhoneSettings/PhoneNumbers";
import Order from "../PhoneSettings/Order";
import BlockedPhone from "../BlockedPhone/BlockedPhone";
import ProceduresManager from "../BookingSettings/ProceduresManager"
import WhiteList from "../WhiteList/WhiteList";
import PhoneExtensions from "../PhoneSettings/PhoneExtensions";
import PhoneSettings from "../PhoneSettings/Settings"
import RoutesSetting from "../PhoneSettings/Routing/Routes";
import Adapter from "../AdapterSetting/AdapterSetting";
import CallList from "../CallReport/CallReport";
import PaymentList from "../PaymentReport/PaymentReport";
import PaymentRequestList from "../PaymentReport/PaymentRequestReport";
import InstallmentReport from "../PaymentReport/InstallmentReport"
import DiscountReport from "../PaymentReport/DiscountReport"
import CallDetail from "../CallReport/CallDetail";
import MonitoringCallDetail from "../Monitoring/MonitoringCallDetail";
import Subscription from "../Subscription/Subscription";
import Bundles from "../Subscription/Bundles";
import Addons from "../Subscription/Addons";
import UserManagement from "../UserManagement/UserManagement";
import AllCustomers from "../Admin/AllCustomers";
import SmsIssues from "../Admin/SmsIssues"
import Partners from "../Admin/Partners";
import PartnerUsers from "../Admin/PartnerUsers";
import Inbox from "../Inbox/Inbox";
import InboxMessages from "../Inbox/InboxMessages";
import StripeConnect from "../StripeConnect/StripeConnect";
import StripePartner from "../StripeConnect/StripePartner";
import UnscheduledReport from "../Reports/Unscheduled"
import AuditTrail from "../Reports/Audit"
import CampaignReport from "../Reports/CampaignReport"
import FormReport from "../Reports/Forms"
import HuddleReport from "../Reports/Huddle"
import AdecConnect from "../Adec/Settings";
import GDMSSettings from "../GDMS/Settings";
import Invoices from "../Invoices/Invoices";
import Dashboard from "../Dashboard/Dashboard";
import Campaigns from "../Campaigns/Campaigns";
import BookingSettings from "../BookingSettings/BookingSettings"
import NotificationSettings from "../NotificationSettings/NotificationSettings";
import Forms from "../Forms/Forms";
import HistoryTemplate from "../HistorySettings/History";
import HRSettings from "../HR/HRSettings";
import Payroll from "../HR/Payroll"
import EditHistoryTemplate from "../HistorySettings/EditHistory";
import GenericSettings from "../GenericSettings/GenericSettings"
import AutopilotSettings from "../GenericSettings/AutopilotSettings"
import Information from "../GenericSettings/Information"
import Widget from "../GenericSettings/Widget"
import CustomizeAI from "../CustomizeAi/CustomizeAI"
import ChangePassword from "../ChangePassword/ChangePassword";
import AppointmentCalendar from "../AppointmentCalendar/AppointmentCalendar"
import Jobs from "../Jobs/jobs"
import SignDocument from "../SignDocument/SignDocument"
import DiscountPlanAdmin from "../DiscountPlans/planAdmin"
import PatientHistory from "../PatientComponents/History"
import Appointments from "../PatientComponents/Appointments"
import PatientDiscountPlan from "../PatientComponents/PatientDiscountPlan"
import ServiceDetails from "../PatientComponents/Scheduling/ServiceDetails"
import ServiceDays from "../PatientComponents/Scheduling/ServiceDays"
import Scheduling from "../PatientComponents/Scheduling/Scheduling"
import PatientForms from "../PatientComponents/Forms"
import PatientPayments from "../PatientComponents/Payments"
import ActionBar from "../ActionBar/ActionBar";
import {Routes, Route, useLocation} from "react-router-dom";
import ProfileSettings from "../ProfileSettings/ProfileSettings";
import LeadReport from "../Reports/Leads"
import AIReport from "../AiReport/AiReport"
import AIProductionReport from "../AiReport/AiProductionReport"
import CallMonitoring from "../Monitoring/CallMonitoring"
import ChatMonitoring from "../Monitoring/ChatMonitoring";
import POMonitoring from "../Monitoring/POMonitoring";
import POPrompts from "../Prompts/POPrompts"
import VAMPrompts from "../Prompts/VAMPrompts"
import VAVPrompts from "../Prompts/VAVPrompts";
import EzraPrompts from "../Prompts/EzraPrompts";
import MetadataPrompts from "../Prompts/MetadataPrompts";

import "./MainComponent.css";
import {
  Flex,
  useColorMode,
  Box,
} from "@chakra-ui/react";

const outreachConfig = ()=>{
  const configuration = [
    {
      title: 'Business Information',
      inputs: [
        {
          type: 'input',
          name: 'Business Website URL',
          pattern: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/, // url regex
          id: 'campaigns.business_website_url'
        },
        {
          type: 'input',
          name: 'Landing URL',
          pattern: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/, // url regex
          id: 'campaigns.landing_url'
        },
          {
            type: 'input',
            name: 'Privacy Policy',
            id: 'campaigns.privacy_policy'
          },
          {
            type: 'input',
            name: 'Contact Us Email',
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // email regex
            id: 'campaigns.contact_us_email'
          },
          {
            type: 'input',
            name: 'Alternative Phone',
            pattern: /^(\+?[1-9]\d{1,14})?(\(\d{1,4}\)|\d{1,4})?[-.\s]?(\d{1,4}[-.\s]?){1,3}\d{1,4}$/, // phone regex
            id: 'campaigns.alternative_phone'
          }]
    },
    {
      title: 'Using Responsible Party Contacts',
      description: 'These are the configrations related to the communicaitons with people who have guardians.',
      inputs: [
        {
          type : 'input',
          name: 'Max Age of Dependents',
          pattern : /^[1-9]\d?$/,
          id : 'responsible_party_end_age'
        },
        {
          type: 'radio',
          id: 'responsible_party_communication',
          options: [
            { label: 'Allow use of contact information on patient record if responsible party contact information is invalid', value: 'use_patient_if_rp_invalid' },
            { label: 'Never use contact information on patient record even if responsible party contact information is invalid', value: 'use_only_rp' },
            { label: 'Never use responsible party contacts', value: 'always_use_patient' },
          ],
        }
      ],
    },
    {
      title: 'Family Grouping',
      description: 'Works only with the {{.GroupAppointments}} placeholder for emails and overrides Call reduction for phone calls.',
      inputs: [
        {
          type: 'switch',
          id: 'family_grouping_enabled',
          name: 'Group same day appts into one message if RP and patient share the same information',
        }
      ],
    },
    {
      title : 'Enable Overlap protection for Automated and Manual Campaigns',
      description : 'Which type of campaigns should we enable overlap protection for.',
      inputs : [{
        type: 'select',
        isMulti: true,
        id: 'campaign_overlap_protection',
        name: '',
        options: [
          { label: 'Reminder', value: 'reminder' },
          { label: 'Manual', value: 'campaign-manual' },
          { label: 'Birthday', value: 'campaign-birthday' },
          { label: 'Welcome', value: 'campaign-welcome' },
        ],
      },
      ]
    },
    {
      title : 'Group Appointment placeholder for Confirmation Campaigns',
      description : '',
      inputs : [
        {
          type : 'switch',
          id : 'include_all_future_appointments_in_confirmation',
          name : 'Include all future appointments in confirmation'
        }
      ]
    },
    {
      title: 'Outgoing Phone Calls',
      description: '',
      inputs: [
        {
          type : 'select',
          isMulti: false,
          name: 'Max concurrent phone calls from phone campaigns',
          id : 'concurrent_calls.max',
          options: [
            { label: '1', value: 1 },
            { label: '2', value: 2 },
            { label: '3', value: 3 },
          ],
        }
      ]
    }
  ];
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
  >
    <GenericSettings configuration={configuration} endpoint={'/settings/campaigns'}/>
    </Box>
  )
}

const WrapScheduling = ()=>{
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
    >
    <Scheduling />
    </Box>
  )
}

const WrapServiceDetails = ()=>{
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
    >
    <ServiceDetails />
    </Box>
  )
}

const WrapServiceDays = ()=>{
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
    >
    <ServiceDays />
    </Box>
  )
}

const LeadSettings = ()=>{
  const configuration=[
    {
      title : 'Lead Tracking',
      description : 'Settings are related to how leads are tracked. Leads are when we detect that somebody who is not an existing patient is contacting your practice over any channel.',
      inputs : [
        {
          type : 'select',
          isMulti : false,
          id : 'conversion_rule',
          name : 'Select the rule that defines who should be considered a new patient',
          options : [
            {
              label : 'Existing patients with last appointments before 18 months ago or within the last 14 days onward (or no appointments in the past) are considered new patients',
              value : 0
            },
            {
              label : 'Existing patients with last appointments before 18 months ago (or no appointment in the past) and at least one in the future are considered new patients',
              value : 3
            },
            {
              label : 'Existing patients with last appointments within the last 14 days onward are considered new patients',
              value : 1
            },
            {
              label : 'Existing patients are the ones without any appointments in the past but an appointment in the future',
              value : 2
            },
          ]
        },{
          type : 'switch',
          name : 'Auto create campaigns on incoming calls',
          id : 'auto_create_on_incoming'
        },{
          type : 'switch',
          name : 'Auto create campaigns on visiting ols',
          id : 'auto_create_on_ols'
        }
      ]
    }
  ]
  return (
    <GenericSettings configuration={configuration} endpoint={'/settings/leads'} supportBatching={true}/>
  )
}

const PatientPortalSettings = ()=>{
  const configuration=[
    {
      title : 'Patient Portal',
      description : 'You can turn patient portal features on or off for your patients.',
      inputs : [
        {
          type : 'switch',
          name : 'Dashboard',
          id : 'patient_portal.dashboard'
        },{
          type : 'switch',
          name : 'Appointments',
          id : 'patient_portal.appointments'
        },{
          type : 'switch',
          name : 'Inbox',
          id : 'patient_portal.inbox'
        },{
          type : 'switch',
          name : 'Forms and History',
          id : 'patient_portal.forms'
        },{
          type : 'switch',
          name : 'Payments',
          id : 'patient_portal.payments'
        },{
          type : 'switch',
          name : 'Profile',
          id : 'patient_portal.profile'
        },{
          type : 'switch',
          name : 'Notifications',
          id : 'patient_portal.notifications'
        }
      ]
    }
  ]
  return (
    <GenericSettings configuration={configuration} endpoint={'/settings/business'} method={'put'}/>
  )
}

import {useAppContext} from "../../AppContext";
import TemplateEditor from "../TemplateEditor/TemplateEditor";
import SocialMedia from "../GenericSettings/SocialMedia";
import IntercomMessages from "../Inbox/IntercomMessages";
import TeamMessages from "../Inbox/TeamMessages";
import GroupChatMessages from "../Inbox/GroupChatMessages";
import RateAppt from "../PatientComponents/RateAppt";
import CustomizeAIHistoryList from "../CustomizeAi/CustomizeAIHistoryList";
import CustomizeAiHistoryDetail from "../CustomizeAi/CustomizeAIHistoryDetail";
import CustomizeAIManualEdit from "../CustomizeAi/CustomizeAIManualEdit";
import { CustomizeAIAssistant } from "../CustomizeAi/CustomizeAIAssistant";
import MonitoringChatDetail from "../Monitoring/MonitoringChatDetail";
import MonitoringPODetail from "../Monitoring/MonitoringPODetail";


export default function MainComponent({isCollapsed, isMobile, toggleMenuCollapse, addActionBarItem, removeActionBarItem, actionBarItems}) {

  const {
    chatContext,
    setChatContext,
    chatSessionId,
    setChatSessionId,
    selectedBusiness,
    isProfileChanged,
    setIsProfileChanged
  } = useAppContext();

  const internalPages = {
    "/settings/adapter": Adapter,
    "/phones/numbers": PhoneNumbers,
    "/phones/settings" : PhoneSettings,
    "/phones/order": Order,
    "/settings/blocked": BlockedPhone,
    "/settings/proc-duration" : ProceduresManager,
    "/phones/extensions": PhoneExtensions,
    "/settings/history" : HistoryTemplate,
    "/phones/routing": RoutesSetting,
    "/settings/notifications": NotificationSettings,
    "/settings/discount-plans" : DiscountPlanAdmin,
    "/notifications": NotificationSettings,
    "/settings/booking": BookingSettings,
    "/settings/patient-portal" : PatientPortalSettings,
    "/reports/calls": CallList,
    "/reports/audit" : AuditTrail,
    "/reports/campaigns" : CampaignReport,
    "/reports/ai_actions" : AIReport,
    "/reports/ai_revenue" : AIProductionReport,
    "/reports/forms" : FormReport,
    "/reports/leads": LeadReport,
    "/reports/unscheduled" : UnscheduledReport,
    "/reports/huddle" : HuddleReport,
    "/settings/subscription": Subscription,
    "/settings/autopilot" : AutopilotSettings,
    "/settings/users": UserManagement,
    "/locations": AllCustomers,
    "/sms-issues" : SmsIssues,
    "/partners": Partners,
    "/jobs" : Jobs,
    "/monitoring/calls": CallMonitoring,
    "/monitoring/chats": ChatMonitoring,
    "/monitoring/po-sessions": POMonitoring,
    "/prompts/po-prompts": POPrompts,
    "/prompts/vam-prompts": VAMPrompts,
    "/prompts/vav-prompts": VAVPrompts,
    "/prompts/ezra-prompts": EzraPrompts,
    "/prompts/metadata-prompts": MetadataPrompts,
    "/template-editor": TemplateEditor,
    "/bundles" : Bundles,
    "/addons" : Addons,
    "/inbox": Inbox,
    "/tasks": Inbox,
    "/intercom" : Inbox,
    "/team" : Inbox,
    "/settings/stripe" : StripeConnect,
    "/stripe" : StripePartner,
    "/settings/a-dec" : AdecConnect,
    "/settings/gdms" : GDMSSettings,
    "/gdms" : GDMSSettings,
    "/reports/payments" : PaymentList,
    "/payroll" : Payroll,
    "/reports/payment-requests" : PaymentRequestList,
    '/payments' : PatientPayments,
    "/reports/installments" : InstallmentReport,
    "/reports/discount" : DiscountReport,
    "/history" : PatientHistory,
    "/whitelist" : WhiteList,
    "/invoices" : Invoices,
    '/outreach' : Campaigns,
    '/settings/profile' : ProfileSettings,
    '/settings/outreach' : outreachConfig,
    '/settings/widget' : Widget,
    '/settings/leads' : LeadSettings,
    '/settings/customize-ai': CustomizeAI,
    '/settings/customize-ai/assistant': CustomizeAIAssistant,
    '/settings/customize-ai/history': CustomizeAIHistoryList,
    '/settings/customize-ai/history/:historyId': CustomizeAiHistoryDetail,
    '/settings/customize-ai/edit': CustomizeAIManualEdit,
    '/settings/social': SocialMedia,
    '/settings/information' : Information,
    '/settings/forms' : Forms,
    '/settings/hr' : HRSettings,
    "/partners/:partner_id" : PartnerUsers,
    '/discount-plans' : PatientDiscountPlan,
    '/appointments' : Appointments,
    '/calendar' : AppointmentCalendar,
    '/forms' : PatientForms,
    "/" : Dashboard
  };

  const {colorMode, toggleColorMode} = useColorMode();
  const [localColorMode] = useState(colorMode);
  const location = useLocation();

  useEffect(() => {
    if (isProfileChanged && localColorMode !== colorMode) {
      toggleColorMode();
      setIsProfileChanged(false);
    }
  }, [location]);

  const renderInternalPage = (displayedInternalPage) => {
    const ComponentToRender = internalPages[displayedInternalPage];
    if (ComponentToRender) {
      return <ComponentToRender selectedBusiness={selectedBusiness}/>;
    }
    return null;
  };


  useEffect(() => {
    localStorage.setItem("chakra-ui-color-mode", colorMode);
  }, [colorMode]);

  return (
    <Flex className="main-wrapper">
      {isCollapsed && isMobile &&
        (<ActionBar
          actionBarItems={actionBarItems}
          toggleMenuCollapse={toggleMenuCollapse}
          isCollapsed={isCollapsed}
          isMobile={isMobile}
        />)}
        <Flex className="content-wrapper">
          <Routes key={location.search || "default"}>
            <Route
              path="/oracle"
              element={<ChatComponent
                chatContext={chatContext}
                setChatContext={setChatContext}
                chatSessionId={chatSessionId}
                setChatSessionId={setChatSessionId}
                selectedBusiness={selectedBusiness}
              />}
            />
            <Route
              path="/patient/:patientId"
              element={<ChatComponent
                chatContext={chatContext}
                setChatContext={setChatContext}
                chatSessionId={chatSessionId}
                setChatSessionId={setChatSessionId}
                selectedBusiness={selectedBusiness}
              />}
            />
            <Route
              path="/po"
              element={<ChatComponent
                chatContext={chatContext}
                setChatContext={setChatContext}
                chatSessionId={chatSessionId}
                setChatSessionId={setChatSessionId}
                selectedBusiness={selectedBusiness}
              />}
            />
            <Route
              path="/history/:sessionId"
              element={<ChatComponent
                chatContext={chatContext}
                setChatContext={setChatContext}
                chatSessionId={chatSessionId}
                setChatSessionId={setChatSessionId}
                selectedBusiness={selectedBusiness}
              />}
            />
            <Route
              path="/payroll/me/:period"
              element={<Payroll/>}
            />
            <Route
              path="/sign/:request_id"
              element={<SignDocument/>}
            />
            <Route path="/reports/calls/:callId" element={<CallDetail/>}/>
            <Route path="/monitoring/calls/:callId" element={<MonitoringCallDetail/>}/>
            <Route path="/monitoring/chats/:chatId" element={<MonitoringChatDetail/>}/>
            <Route path="/monitoring/po-sessions/:sessionId" element={<MonitoringPODetail/>}/>


            <Route path="/appointments/new" element={<WrapScheduling/>}/>
            <Route path="/appointments/new/service/:serviceId" element={<WrapServiceDetails/>}/>
            <Route path="/appointments/new/service/:serviceId/:date" element={<WrapServiceDays/>}/>

            <Route path="/rateappt" element={<RateAppt/>}/>

            <Route path="/settings/history/:template_id" element={<EditHistoryTemplate/>}/>
            <Route path="/password_change" element={<ChangePassword/>}/>
            {Object.keys(internalPages).map((route) => (
              <Route key={route} path={route} element={renderInternalPage(route)}/>))}

            <Route path="/inbox/:uid" element={<InboxMessages isMobile={isMobile} addActionBarItem={addActionBarItem}
                                                              removeActionBarItem={removeActionBarItem}/>}/>
            <Route path="/tasks/:uid" element={<InboxMessages isMobile={isMobile} addActionBarItem={addActionBarItem}
                                                              removeActionBarItem={removeActionBarItem}/>}/>
            <Route path="/intercom/:uid" element={<IntercomMessages isMobile={isMobile} addActionBarItem={addActionBarItem}
                                                              removeActionBarItem={removeActionBarItem}/>}/>
            <Route path="/team/group/:groupId" element={<GroupChatMessages isMobile={isMobile} addActionBarItem={addActionBarItem}
                                                              removeActionBarItem={removeActionBarItem}/>}/>
            <Route path="/team/:uid" element={<TeamMessages isMobile={isMobile} addActionBarItem={addActionBarItem}
                                                              removeActionBarItem={removeActionBarItem}/>}/>
          </Routes>
        </Flex>
    </Flex>
  );
}
